export default __webpack_public_path__ + "static/media/status_error.e47c338a.svg";